import React from 'react';
import './FindYourPerfectHome.css';
import image1 from "../components/asstes/Screenshot 2025-02-06 160833.png"
const FindYourPerfectHome = () => {
        const phoneNumber = "919934822681"; 
  const message = "Hello, I want to connect with you."; 

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); // New tab में खुलेगा
  };
  return (

    <div className="container">
      <h2 className="heading"> Projects</h2>
      <div className="card-container">
        {/* First Card */}
        <div className="card">
          <div className="card-image-wrapper">
            <img
              src={image1}
              style={{height:"250px",}}
              alt="Modern Apartment"
            />
            <button className="card-badge" onClick={handleClick}>For Sale</button>
          </div>
          <h4>Under Construction </h4>
  {/** <p>$ 175,000</p>*/} 
          {/*<p>3 bd / 2 ba / 1100 Sq Ft</p>*/}
        </div>

        {/* Second Card */}
        <div className="card">
          <div className="card-image-wrapper">
            <img
              src="https://websitedemos.net/real-estate-02/wp-content/uploads/sites/430/2020/01/estate-family-home.jpg"
              alt="Family Home"
              style={{height:"250px"}}
            />
            <button onClick={handleClick} className="card-badge" style={{ backgroundColor: '#f6bc98' }}>
              For Sale
            </button>
          </div>
          <h4>2 BHK</h4>
           {/** <p>$ 175,000</p>*/} 
          {/*<p>3 bd / 2 ba / 1100 Sq Ft</p>*/}
        </div>

        {/* Third Card */}
        <div className="card">
          <div className="card-image-wrapper">
            <img
              src="https://websitedemos.net/real-estate-02/wp-content/uploads/sites/430/2020/02/modern-apartment.jpg"
              alt="Affordable Options"
              style={{height:"250px"}}
            />
            <button onClick={handleClick} className="card-badge">For Sale</button>
          </div>
          <h4>3 BHK</h4>
         {/** <p>$ 175,000</p>*/} 
          {/*<p>3 bd / 2 ba / 1100 Sq Ft</p>*/}
        </div>
        {/**fourth container */}
        
      </div>
    </div>
  );
};

export default FindYourPerfectHome;
